import React from "react";
import PropTypes from "prop-types";
import noop from "lodash/noop";
import { ScreenReaderOnly } from "@xo-union/ui-accessibility";
import { useUniqueID } from "@xo-union/react-unique-id";
import { NextPageLink, PreviousPageLink } from "../DirectionalPageLinks/index.js";
import NumberedPagesAndEllipses from "../NumberedPagesAndEllipses/index.js";
import styles from "./styles.css";
var DefaultLink = function DefaultLink(_ref) {
  var pageLinkProps = _ref.pageLinkProps;
  return /*#__PURE__*/(
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    React.createElement("a", pageLinkProps)
  );
};
process.env.NODE_ENV !== "production" ? DefaultLink.propTypes = {
  pageLinkProps: PropTypes.shape({}).isRequired
} : void 0;
var Pagination = function Pagination(_ref2) {
  var renderLink = _ref2.renderLink,
    activePage = _ref2.activePage,
    onPageChange = _ref2.onPageChange,
    totalPageCount = _ref2.totalPageCount;
  var activePageNumber = Number(activePage);
  var totalPageCountNumber = Number(totalPageCount);
  var descriptionID = useUniqueID();
  var validPageNumber = activePageNumber <= totalPageCountNumber && activePageNumber >= 1;
  return totalPageCountNumber > 1 && validPageNumber && /*#__PURE__*/React.createElement("nav", {
    "aria-describedby": descriptionID
  }, /*#__PURE__*/React.createElement("ul", {
    className: styles.container,
    role: "list"
  }, activePageNumber > 1 && /*#__PURE__*/React.createElement(PreviousPageLink, {
    renderLink: renderLink,
    onPageChange: onPageChange,
    activePage: activePageNumber,
    totalPageCount: totalPageCountNumber
  }), /*#__PURE__*/React.createElement(NumberedPagesAndEllipses, {
    renderLink: renderLink,
    activePage: activePageNumber,
    onPageChange: onPageChange,
    totalPageCount: totalPageCountNumber
  }), activePageNumber < totalPageCountNumber && /*#__PURE__*/React.createElement(NextPageLink, {
    renderLink: renderLink,
    onPageChange: onPageChange,
    activePage: activePageNumber,
    totalPageCount: totalPageCountNumber
  })), /*#__PURE__*/React.createElement(ScreenReaderOnly, {
    id: descriptionID
  }, "Pagination, viewing page ".concat(activePage, " of ").concat(totalPageCount)));
};
process.env.NODE_ENV !== "production" ? Pagination.propTypes = {
  /**
   * page that should be selected
   */
  activePage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /**
   * function to be called when the changes pages
   */
  onPageChange: PropTypes.func,
  /**
   * total number of pages in given list
   */
  totalPageCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /**
   * Component to render in place of links. Use this to customize the `href` or implement client side routing
   */
  renderLink: PropTypes.func
} : void 0;
Pagination.defaultProps = {
  onPageChange: noop,
  renderLink: DefaultLink
};
export default Pagination;